import { css } from '@emotion/react'
import { useState, useEffect } from 'react'
import { Route, Routes } from 'react-router'
import { inject, observer } from 'mobx-react'
import _ from 'lodash'
import posed, { PoseGroup } from 'react-pose'
import { withRouterProps } from '../../../utils'
import { Loading } from '../../../components'

import TwoLongLives from './TwoLongLives'
import OneLongLife from './OneLongLife'
import ClientDies from './ClientDies'
import SpouseDies from './SpouseDies'
import EmergencyFund from './EmergencyFund'
import CompanyStock from './CompanyStock'
import Main from './Main'

import { MainPage } from './style'

const RouteContainer = posed.div({
  enter: { opacity: 1, delay: 300, beforeChildren: true },
  exit: { opacity: 0 },
})

function ConsiderationDashboard(props) {
  const {
    location,
    store: {
      person,
      spouse,
      setInitialInfoForSpendDown,
      getPrimaryRetirementStatus,
      getSpouseRetirementStatus,
    },
  } = props
  const [status, setState] = useState('loading')
  const [primaryRetirementStatus, setPrimaryRetirementStatus] = useState({})
  const [spouseRetirementStatus, setSpouseRetirementStatus] = useState({})

  useEffect(() => {
    props.main.setSidebar(false)
    return () => {
      props.main.setSidebar(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchRetirementStatusesForSpendDown = async () => {
    const resultPrimary = await getPrimaryRetirementStatus()
    if (person.includeSpouse) {
      const resultSpouse = await getSpouseRetirementStatus()
      setSpouseRetirementStatus(resultSpouse)
    }
    setPrimaryRetirementStatus(resultPrimary)
  }

  useEffect(() => {
    fetchRetirementStatusesForSpendDown()
    if (_.isEmpty(person || spouse)) {
      handleFetch()
    } else {
      setState('success')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleFetch = async () => {
    try {
      setState('loading')
      await setInitialInfoForSpendDown()
      setState('success')
    } catch (err) {
      setState('error')
      console.error(err)
    }
  }

  if (status === 'loading') {
    return <Loading />
  }

  if (status === 'error') {
    return (
      <div
        css={css`
          color: #e31e27;
          font-size: 14px;
          line-height: 1.5;
          text-align: center;
          padding: 0.25rem 0 0.75rem 0;
        `}>
        Something went wrong, please try again later.
      </div>
    )
  }

  return (
    <PoseGroup animateOnMount>
      <RouteContainer key={location.key || location.pathname}>
        <MainPage.Container>
          <Routes location={location}>
            <Route
              path='/two-long-lives'
              element={
                <TwoLongLives
                  primaryRetirementStatus={primaryRetirementStatus}
                  spouseRetirementStatus={spouseRetirementStatus}
                />
              }
            />
            <Route
              path='/one-long-life'
              element={
                <OneLongLife
                  primaryRetirementStatus={primaryRetirementStatus}
                  spouseRetirementStatus={spouseRetirementStatus}
                />
              }
            />
            <Route
              path='/client-dies'
              element={
                <ClientDies
                  primaryRetirementStatus={primaryRetirementStatus}
                  spouseRetirementStatus={spouseRetirementStatus}
                />
              }
            />
            <Route
              path='/spouse-dies'
              element={
                <SpouseDies
                  primaryRetirementStatus={primaryRetirementStatus}
                  spouseRetirementStatus={spouseRetirementStatus}
                />
              }
            />
            <Route
              path='/emergency-fund'
              element={
                <EmergencyFund
                  primaryRetirementStatus={primaryRetirementStatus}
                  spouseRetirementStatus={spouseRetirementStatus}
                />
              }
            />
            <Route
              path='/company-stock'
              element={
                <CompanyStock
                  primaryRetirementStatus={primaryRetirementStatus}
                  spouseRetirementStatus={spouseRetirementStatus}
                />
              }
            />
            <Route path='*' element={<Main />} />
          </Routes>
        </MainPage.Container>
      </RouteContainer>
    </PoseGroup>
  )
}

export default withRouterProps(inject('store', 'main')(observer(ConsiderationDashboard)))
